const ThreeSix = ({ threeSix }) => {
    return (
        <div className='time-stamp space-y-2'>
            <label className='evening'>3PM- 6PM <span>&#8594;  {threeSix.pct + "%"}</span></label>
            <div><span className='font-semibold'>Total Sales:</span> {threeSix.total_count} X <span>{threeSix.total_sales}</span></div>
            <div className='numbers space-y-2'>
                <div><span>Dine-In :</span>{threeSix.dinein_sales === 'None' ? "-" : <>{threeSix.dinein_count} X {threeSix.dinein_sales}</>}</div>
                <div><span>Order :</span>{threeSix.tab_sales === 'None' ? "-" : <>{threeSix.tab_count} X {threeSix.tab_sales}</>}</div>
            </div>
        </div>
    )
}

export default ThreeSix